// extracted by mini-css-extract-plugin
export default {"container":"Section_container__vEvWA","header":"Section_header__mpTaY","body":"Section_body__rlfdw"};